import { connect } from "react-redux";
import { push } from "react-router-redux";

import KompressorWartung from "./KompressorWartung";

import { prevInstalledCompressorIndex, nextInstalledCompressorIndex,
	genChangeCompressorPath, defaultCompressorPath } from "../model/Kompressor";

export default connect(state => ({
	location_path: state.router.location.pathname,
	default_path: defaultCompressorPath(state, "/maintenance/compressor/"),
	previous_index: prevInstalledCompressorIndex(state.router.location.pathname, state.ablauf.compressors),
	next_index: nextInstalledCompressorIndex(state.router.location.pathname, state.ablauf.compressors)
}), dispatch => ({
	showImage: location_path => {
		let parts = location_path.split("/");
		if (parts[parts.length - 1] === "image") {
			parts.splice(parts.length - 1, 1);
		} else {
			parts.push("image");
		}
		dispatch(push(parts.join("/")));
	},
	gotoCompressor: genChangeCompressorPath(dispatch)
}))(KompressorWartung);
